import { sva } from "@filadd/phi-plus-styled-system/css";
export const sideNavRecipe = sva({
    slots: [
        "root",
        "container",
        "logoBox",
        "subheaderBox",
        "toggleBox",
        "topNav",
        "bottomNav",
    ],
    base: {
        root: {
            display: "flex",
            bgColor: "primary",
            color: "white",
            height: "fullVH",
            p: "1rem 0 0",
            borderTopRightRadius: 30,
            borderBottomRightRadius: 30,
            zIndex: "overlay",
            transition: "width 0.3s ease-in-out",
        },
        container: {
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            height: "full",
            width: "full",
            border: "none",
            boxSizing: "border-box",
            "&::-webkit-scrollbar": {
                width: 2,
            },
            "&::-webkit-scrollbar-thumb": {
                borderRadius: 8,
                background: "primary",
            },
        },
        logoBox: {
            width: "full",
            height: 10,
            mt: 1,
            mb: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "all 0.3s ease-in-out",
            "& img": {
                m: "0 auto",
            },
        },
        subheaderBox: {
            color: "white",
            cursor: "pointer",
            py: 2,
            px: 4,
            overflow: "hidden",
            height: 20,
            transition: "all 0.3s ease-in-out",
            transitionDelay: "0.1s",
            flexShrink: 0,
        },
        toggleBox: {
            px: 4,
        },
        topNav: {
            listStyle: "none",
            m: 0,
            px: 2,
            pt: 0,
            pb: 2,
            position: "relative",
            outline: 0,
            "&::-webkit-scrollbar": {
                width: 2,
            },
            "&::-webkit-scrollbar-thumb": {
                borderRadius: 8,
                background: "primary.400",
            },
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
        },
        bottomNav: {
            width: "full",
            m: "auto 0 0",
            pt: 3,
            px: 2,
            pb: 4,
            bgColor: "white.a3",
            borderTopLeftRadius: 30,
            borderTopRightRadius: 30,
            "&:first-child": {
                borderTopLeftRadius: 30,
                borderTopRightRadius: 30,
            },
            "&:last-child": {
                borderBottomRightRadius: 30,
            },
        },
    },
    variants: {
        collapsed: {
            true: {
                root: {
                    width: 20,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                },
                container: {
                    overflow: "none",
                },
                topNav: {
                    display: "flex",
                    flexDirection: "column",
                },
                subheaderBox: {
                    opacity: 0,
                    overflow: "hidden",
                    visibility: "hidden",
                },
            },
            false: {
                root: {
                    width: "navbarExpandedWidth",
                },
                subheaderBox: {
                    opacity: 1,
                    overflow: "hidden",
                    transition: "all 0.2s ease",
                    transitionDelay: "0.2s",
                    visibility: "visible",
                },
            },
        },
    },
});
//# sourceMappingURL=sideNavRecipe.js.map